import { memo, useEffect, useState } from 'react';

import useSetQuery from 'hooks/useSetQuery';
import useSearch from 'hooks/useSearch';
import { Button, ButtonGroup, Skeleton } from '@mui/material';

export default memo(function OrderStatusFilterComponent({ isLoading, data }) {
  const setQuery = useSetQuery();
  const query = useSearch();

  useEffect(() => {
    if (!query.get('status')) {
      setQuery('status', 1);
    }
  }, [query.get('status')]);

  return (
    <ButtonGroup size='large'>
      {isLoading || !data?.length ? (
        <>
          <Button>
            <Skeleton animation='pulse' width={80} />
          </Button>
          <Button>
            <Skeleton animation='pulse' width={80} />
          </Button>
          <Button>
            <Skeleton animation='pulse' width={80} />
          </Button>
        </>
      ) : (
        data?.map((status) => (
          <Button
            key={status?.id}
            onClick={() => setQuery('status', status?.id)}
            variant={`${
              query.get('status') == status?.id ? 'contained' : 'outlined'
            }`}
          >
            {status?.name}
          </Button>
        ))
      )}
    </ButtonGroup>
  );
});
